import { namespaceActions } from 'modules/redux-utils'
import { NAME } from './constants'

// Employee constants
const LOAD_EMPLOYEE = 'LOAD_EMPLOYEE'
const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE'

// Dependent Constants
const ADD_DEPENDENT = 'ADD_DEPENDENT'
const DELETE_DEPENDENT_BYINDEX = 'DELETE_DEPENDENT_BYINDEX'
const LOAD_DEPENDENTS_LIST = 'LOAD_DEPENDENTS_LIST'
const SET_ERROR = 'SET_ERROR'
const UPDATE_DEPENDENT_BYINDEX = 'UPDATE_DEPENDENT_BYINDEX'

export default namespaceActions(NAME)([
  LOAD_EMPLOYEE,
  UPDATE_EMPLOYEE,

  ADD_DEPENDENT,
  DELETE_DEPENDENT_BYINDEX,
  LOAD_DEPENDENTS_LIST,
  SET_ERROR,
  UPDATE_DEPENDENT_BYINDEX,
])
